export interface TimezoneOption {
  value: string;
  label: string;
  region: string;
  utcOffset: string;
}

export const COMMON_TIMEZONES: TimezoneOption[] = [
  // North America
  { value: 'America/New_York', label: 'Eastern Time (ET)', region: 'North America', utcOffset: 'UTC-5/-4' },
  { value: 'America/Chicago', label: 'Central Time (CT)', region: 'North America', utcOffset: 'UTC-6/-5' },
  { value: 'America/Denver', label: 'Mountain Time (MT)', region: 'North America', utcOffset: 'UTC-7/-6' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)', region: 'North America', utcOffset: 'UTC-8/-7' },
  { value: 'America/Vancouver', label: 'Vancouver (PT)', region: 'North America', utcOffset: 'UTC-8/-7' },
  { value: 'America/Toronto', label: 'Toronto (ET)', region: 'North America', utcOffset: 'UTC-5/-4' },
  { value: 'America/Mexico_City', label: 'Mexico City', region: 'North America', utcOffset: 'UTC-6/-5' },

  // South America
  { value: 'America/Sao_Paulo', label: 'São Paulo (BRT)', region: 'South America', utcOffset: 'UTC-3' },
  { value: 'America/Buenos_Aires', label: 'Buenos Aires (ART)', region: 'South America', utcOffset: 'UTC-3' },
  { value: 'America/Lima', label: 'Lima (PET)', region: 'South America', utcOffset: 'UTC-5' },
  { value: 'America/Bogota', label: 'Bogotá (COT)', region: 'South America', utcOffset: 'UTC-5' },

  // Europe
  { value: 'Europe/London', label: 'London (GMT/BST)', region: 'Europe', utcOffset: 'UTC+0/+1' },
  { value: 'Europe/Paris', label: 'Paris (CET/CEST)', region: 'Europe', utcOffset: 'UTC+1/+2' },
  { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)', region: 'Europe', utcOffset: 'UTC+1/+2' },
  { value: 'Europe/Rome', label: 'Rome (CET/CEST)', region: 'Europe', utcOffset: 'UTC+1/+2' },
  { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)', region: 'Europe', utcOffset: 'UTC+1/+2' },
  { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)', region: 'Europe', utcOffset: 'UTC+1/+2' },
  { value: 'Europe/Stockholm', label: 'Stockholm (CET/CEST)', region: 'Europe', utcOffset: 'UTC+1/+2' },
  { value: 'Europe/Moscow', label: 'Moscow (MSK)', region: 'Europe', utcOffset: 'UTC+3' },

  // Asia
  { value: 'Asia/Kolkata', label: 'India (IST)', region: 'Asia', utcOffset: 'UTC+5:30' },
  { value: 'Asia/Delhi', label: 'Delhi (IST)', region: 'Asia', utcOffset: 'UTC+5:30' },
  { value: 'Asia/Mumbai', label: 'Mumbai (IST)', region: 'Asia', utcOffset: 'UTC+5:30' },
  { value: 'Asia/Dhaka', label: 'Dhaka (BST)', region: 'Asia', utcOffset: 'UTC+6' },
  { value: 'Asia/Karachi', label: 'Karachi (PKT)', region: 'Asia', utcOffset: 'UTC+5' },
  { value: 'Asia/Shanghai', label: 'Shanghai (CST)', region: 'Asia', utcOffset: 'UTC+8' },
  { value: 'Asia/Beijing', label: 'Beijing (CST)', region: 'Asia', utcOffset: 'UTC+8' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)', region: 'Asia', utcOffset: 'UTC+9' },
  { value: 'Asia/Seoul', label: 'Seoul (KST)', region: 'Asia', utcOffset: 'UTC+9' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)', region: 'Asia', utcOffset: 'UTC+8' },
  { value: 'Asia/Singapore', label: 'Singapore (SGT)', region: 'Asia', utcOffset: 'UTC+8' },
  { value: 'Asia/Bangkok', label: 'Bangkok (ICT)', region: 'Asia', utcOffset: 'UTC+7' },
  { value: 'Asia/Jakarta', label: 'Jakarta (WIB)', region: 'Asia', utcOffset: 'UTC+7' },
  { value: 'Asia/Manila', label: 'Manila (PST)', region: 'Asia', utcOffset: 'UTC+8' },
  { value: 'Asia/Dubai', label: 'Dubai (GST)', region: 'Asia', utcOffset: 'UTC+4' },
  { value: 'Asia/Riyadh', label: 'Riyadh (AST)', region: 'Asia', utcOffset: 'UTC+3' },
  { value: 'Asia/Tehran', label: 'Tehran (IRST/IRDT)', region: 'Asia', utcOffset: 'UTC+3:30/+4:30' },

  // Africa
  { value: 'Africa/Cairo', label: 'Cairo (EET/EEST)', region: 'Africa', utcOffset: 'UTC+2/+3' },
  { value: 'Africa/Lagos', label: 'Lagos (WAT)', region: 'Africa', utcOffset: 'UTC+1' },
  { value: 'Africa/Johannesburg', label: 'Johannesburg (SAST)', region: 'Africa', utcOffset: 'UTC+2' },
  { value: 'Africa/Nairobi', label: 'Nairobi (EAT)', region: 'Africa', utcOffset: 'UTC+3' },
  { value: 'Africa/Casablanca', label: 'Casablanca (WEST)', region: 'Africa', utcOffset: 'UTC+1/+0' },

  // Oceania
  { value: 'Australia/Sydney', label: 'Sydney (AEDT/AEST)', region: 'Oceania', utcOffset: 'UTC+10/+11' },
  { value: 'Australia/Melbourne', label: 'Melbourne (AEDT/AEST)', region: 'Oceania', utcOffset: 'UTC+10/+11' },
  { value: 'Australia/Perth', label: 'Perth (AWST)', region: 'Oceania', utcOffset: 'UTC+8' },
  { value: 'Pacific/Auckland', label: 'Auckland (NZDT/NZST)', region: 'Oceania', utcOffset: 'UTC+12/+13' },

  // Other
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', region: 'Other', utcOffset: 'UTC+0' },
];

export const getTimezonesByRegion = (region: string): TimezoneOption[] => {
  return COMMON_TIMEZONES.filter(tz => tz.region === region);
};

export const searchTimezones = (query: string): TimezoneOption[] => {
  const lowercaseQuery = query.toLowerCase();
  return COMMON_TIMEZONES.filter(tz =>
    tz.label.toLowerCase().includes(lowercaseQuery) ||
    tz.region.toLowerCase().includes(lowercaseQuery) ||
    tz.value.toLowerCase().includes(lowercaseQuery)
  );
};

// Group timezones by region for better UX
export const TIMEZONE_GROUPS = COMMON_TIMEZONES.reduce((acc, tz) => {
  if (!acc[tz.region]) {
    acc[tz.region] = [];
  }
  acc[tz.region].push(tz);
  return acc;
}, {} as Record<string, TimezoneOption[]>);
